export default "__VITE_ASSET__U1Dkl9IG__"